import { useQuery } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import { UploadHistory } from '../types/backend-dto-types';
import { useFetcher } from '../useGetFetchConfig';

export const useGetMatterUploadHistory = (matterId: string, options?: { refetchInterval?: number | false }) => {
  const fetcher = useFetcher();

  return useQuery<UploadHistory[]>(
    [QueryEntity.UploadHistory, { matterId }],
    () => fetcher(`${APIBaseChronos}/api/matter/${matterId}/upload-metadata/history`),
    {
      enabled: !!matterId,
      refetchOnWindowFocus: false,
      refetchInterval: options?.refetchInterval ?? false,
    },
  );
};
